// extracted by mini-css-extract-plugin
export default {"input":"styles-module__input__src-labstep-web-core-SearchBar-_wQNQa"};